module.exports = __webpack_public_path__ + "img/5_2023-04-20--TERRY-FOX-Duo-dryfit-women.4785b96a.jpg";